import { render, staticRenderFns } from "./_Commission.vue?vue&type=template&id=298fdf56"
import script from "./_Commission.vue?vue&type=script&lang=js"
export * from "./_Commission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports